exports['default'] = {
    Rec: require('./rec'),
    Nav: require('./nav').default,
    Book: require('./book').default,
    Header: require('./header').default,
    SubHeader: require('./subheader').default,
    Ad: require('./ad').default,
    Catalog: require('./catalog').default,
    Icon: require('./icon').default,
    Divider: require('./divider').default,
    Star: require('./star').default,
    NavTop: require('./nav_top').default,
    BigBanner: require('./big_banner').default,
}
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./src/component/index.js